<div class="login-header font-15 bg-top-menu color-light">
    <ng-container  *ngIf="subtitles.downloaded">
    <div class="login-header__language-box" (click)="toggleLanguagesList()">
        <div *ngIf="subtitles.languagesList.length >= 2 && !externalLogin" class="cursor-pointer">
            <img class="login-header__language-icon"
                 ngSrc="./assets/img/top_menu/interface.svg"
                 width="35" height="35" alt="">
            <div class="login-header__language-text">
                <span>{{ subtitles.languageName }}</span>
                <img class="login-header__arrow-down-icon"
                     ngSrc="/assets/img/top_menu/arrow_down.svg"
                     width="16" height="16" alt="">
            </div>
            <div class="languages-list bg-top-menu box-shadow" *ngIf="showLanguagesList" [ngStyle]="{'max-height': windowHeight - 90 + 'px'}">
                <div *ngFor="let lang of subtitles.languagesList" class="languages-list__element cursor-pointer" (click)="getSubtitles(lang.shortcut)">
                    <div class="languages-list__element-inner color-light">{{ lang.name }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="login-header__login-box cursor-pointer" (click)="loginScreen()">
        <img class="login-header__icon" src="./assets/img/top_menu/user.svg" alt="">
        <div class="login-header__text" [innerText]="subtitle(1129) | uppercase"></div>
    </div>

    <div class="login-header__register-box cursor-pointer" (click)="registrationScreen()">
        <img *ngIf="!externalLogin" class="login-header__icon login-header__icon--register" src="./assets/img/top_menu/registration.svg" alt="">
        <div *ngIf="!externalLogin" class="login-header__text login-header__text--register" [innerText]="subtitle(652) | uppercase"></div>
    </div>
    </ng-container>
</div>
